import { authorizeMe, axiosInstance } from "./commonHeadApiLogic.js";

// wrapper already defined by you
const withAuthorization = async (apiFunction, ...args) => {
  try {
    await authorizeMe();
    return await apiFunction(...args);
  } catch (error) {
    console.error("Error in API request:", error);
    throw error;
  }
};


export const getServicesAPI = () => {
  return withAuthorization(async () => {
    return axiosInstance.get(
      `/api/admins/services/names-only`
    );
  });
};

export const getAdditionalServicesByServiceIdAPI = (serviceId) => {
  return withAuthorization(async () => {
    return axiosInstance.get(
      `/api/admins/additional-services/${serviceId}`
    );
  });
};

export const updateAdditionalServiceAPI = (additionalServiceId, payload) => {
  return withAuthorization(async () => {
    return axiosInstance.patch(
      `/api/admins/additional-services/${additionalServiceId}`,
      payload
    );
  });
};
